module.exports = __webpack_public_path__ + "static/media/FAQs – Arabic@2x.522ff6fa.jpg";